(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery-florian"] && !Shopify.designMode) return;
  try {
    class FlorianGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fgallery__track');
      if (!this.track) return;

      this.slides = [...this.querySelectorAll('.fgallery__slide')];
      this.thumbs = [...this.querySelectorAll('.fgallery__thumb')];
      this.dots = [...this.querySelectorAll('.fgallery__dot')];
      this.arrows = [...this.querySelectorAll('.fgallery__arrow')];
      this.index = 0;

      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index))));
      this.arrows.forEach((arrow) =>
        arrow.addEventListener('click', () => this.goTo(this.index + Number(arrow.dataset.direction)))
      );
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      });

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
    }

    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(target);
    }

    onScroll() {
      const index = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
      if (index !== this.index) this.setActive(index);
    }

    setActive(index) {
      this.index = index;
      const thumbsWrap = this.querySelector('.fgallery__thumbs');
      this.thumbs.forEach((thumb, i) => {
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          // Only scroll the thumbnail row, never the page
          if (thumbsWrap) {
            thumbsWrap.scrollTo({ left: thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
          }
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

      const [previous, next] = this.arrows;
      if (previous) previous.disabled = index <= 0;
      if (next) next.disabled = index >= this.slides.length - 1;
    }
  }

  if (!customElements.get('florian-gallery')) {
    customElements.define('florian-gallery', FlorianGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
